import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const el = document.createElement('div');
el.classList.add('left-sidebar-wrapper');

function LeftSidebarDesa({ children }) {
    useEffect(() => {
        const elfLeftSidebar = document.getElementById('leftSidebar');
        elfLeftSidebar.appendChild(el);

        return () => {
            elfLeftSidebar.removeChild(el);
        };
    }, []);

    return createPortal(
        <div
            style={{
                transition: 'margin 800ms ease-in-out',
                width: 350,
                zIndex: 1001,
                height: '100vh',
            }}>
            {children}
        </div>,
        el
    );
}

export default LeftSidebarDesa;
